import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Banner from '../Banner';
import useBanners from '../Banner/useBanners.hooks';
import { HITL3_PADDING } from '../../utils/hitl3Spacing';

const useStyles = makeStyles<Theme>(() => ({
  innerCard: {
    margin: 0,
    // Shared 8px inset except the right edge (0), so the banner runs flush to the
    // pane's right edge.
    padding: `${HITL3_PADDING} 0 ${HITL3_PADDING} ${HITL3_PADDING}`,
    backgroundColor: '#F5F9FD',
  },
}));

/**
 * BannerCard — top section of the center card: an inner card that shows the
 * Banner's time-period category notifications (without the EXPAND/CLOSE
 * button). Hidden entirely when there are no banners.
 */
const BannerCard = () => {
  const classes = useStyles();
  const banners = useBanners();

  if (!banners.length) {
    return null;
  }

  return (
    <div className={classes.innerCard}>
      <Banner embedded />
    </div>
  );
};

export default BannerCard;
